<ng-template #userinfoform>
    <upp-form *ngIf="UserForm" [formGroup]="UserForm">
        <upp-form-image style="margin-bottom: 10px;">
            <upp-image uppDataid="user-edit-photo"
                formControlName="photo" 
                crheight="200" 
                crwidth="200" 
                [readonly]="false" 
            ></upp-image>
        </upp-form-image>

        <upp-form-warning uppDataid="useredit-pending-activation"
            *ngIf="user?.IsPending"
            style="margin-bottom: 10px;"            
            color="warning"
            icon="mail-unread-outline"
            slot="start"
            title="{{tr('@user_edit_pending_activation_title')}}"
            subtitle="{{tr('@user_edit_pending_activation_subtitle')}}"
            (click)="OnResendActivationMail()"
        ></upp-form-warning>

        <upp-language-select uppDataid="user-edit-language-select"
            formControlName="language"
            [title]="tr('@user_current_language')"
            (Changed)="OnLanguageApply($event)"
        ></upp-language-select>
        
        <upp-form-section title="{{tr('@user_edit_information')}}">
            <ion-item>
                <upp-input uppDataid="user-edit-firstname-text" 
                    formControlName="firstname" 
                    type='text' 
                    placeholder="{{tr('@user_input_firstname_ph')}}" 
                    title="{{tr('@user_input_firstname')}}"
                ></upp-input>
            </ion-item>
            <ion-item>
                <upp-input uppDataid="user-edit-lastname-text" 
                    formControlName="lastname" 
                    placeholder="{{tr('@user_input_lastname_ph')}}" 
                    title="{{tr('@user_input_lastname')}}"
                ></upp-input>
            </ion-item>
            <ion-item>
                <upp-input uppDataid="user-edit-phonenumber-text" 
                    formControlName="phone" 
                    placeholder="{{tr('@user_input_phonenumber_ph')}}" 
                    title="{{tr('@user_input_phonenumber')}}"
                ></upp-input>
            </ion-item>
        </upp-form-section>

        <upp-form-section title="{{tr('@user_access_information')}}">
            <ion-item>
                <upp-input uppDataid="user-edit-email-text" 
                    formControlName="email" 
                    type='email' 
                    placeholder="{{tr('@user_input_email_ph')}}" 
                    title="{{tr('@user_input_email')}}"
                    [errornfo]="{ 
                        required: tr('@mandatory_field'), 
                        email: tr('@enter_valid_email'), 
                        available: tr('@register_username_not_available') 
                    }"
                ></upp-input>
            </ion-item>
            <ion-button uppDataid="user-edit-password-button" 
                style="margin: 8px 8px 5px 8px;"
                color="dark"
                expand="block"
                fill="outline"
                [disabled]="Mode === 'PASS' || IsChangingPassword"
                (click)="OnUpdatePasword()">
                <ion-icon slot="start" name="key-outline"></ion-icon>
                {{tr('@user_password_update')}}
            </ion-button>
        </upp-form-section>

        <div *ngIf="Mode === 'PASS' && PassForm" [formGroup]="PassForm">
            <upp-form-section title="{{tr('@user_password_update_header')}}">
                <ion-item>
                    <upp-input uppDataid="user-edit-previous-password" 
                        formControlName="previous" 
                        type="password" 
                        placeholder="{{tr('@user_password_old_password_ph')}}" 
                        title="{{tr('@user_password_old_password')}}"
                        [errornfo]="{ 
                            required: tr('@mandatory_field'), 
                            minlength: tr('@minsize_field', [ '8' ]) 
                        }"
                        (Changed)="OnPasswordChanged()">
                    </upp-input>
                </ion-item>  
                <upp-form-warning *ngIf="InvalidPassword" 
                    style="margin-bottom: 5px;"
                    color="warning" 
                    slot="start" 
                    icon="lock-closed-outline" 
                    title="{{tr('@user_invalid_password_warning')}}"
                    subtitle="{{tr('@user_invalid_password_message')}}"
                ></upp-form-warning>    
                <ion-item>
                    <upp-input uppDataid="user-edit-updated-password1" 
                        formControlName="newpass" 
                        type="password" 
                        placeholder="{{tr('@user_password_enter_password_ph')}}" 
                        title="{{tr('@user_password_enter_password')}}"
                        [errornfo]="{ 
                            required: tr('@mandatory_field'), 
                            minlength: tr('@minsize_field', [ '8' ]),
                            samepwd: tr('@user_password_same_warning')
                        }"
                    ></upp-input>
                </ion-item>        
                <ion-item>
                    <upp-input uppDataid="user-edit-updated-password2" 
                        formControlName="confirm" 
                        type="password"
                        placeholder="{{tr('@user_password_enter_confirm_ph')}}" 
                        title="{{tr('@user_password_enter_confirm')}}"
                        [errornfo]="{ 
                            required: tr('@mandatory_field'), 
                            minlength: tr('@minsize_field', [ '8' ]), 
                            nomatch: tr('@register_password_doesnt_match') 
                        }"
                    ></upp-input>
                </ion-item>
                <div class="password-actions">
                    <ion-button uppDataid="user-edit-submit-password"
                        fill="clear"
                        color="success"
                        [disabled]="!CanAcceptPassword || IsChangingPassword"
                        (click)="AcceptPassword()">
                        <ion-icon slot="icon-only" name="checkmark-circle-outline"></ion-icon>
                    </ion-button>
                    <ion-button uppDataid="user-edit-cancel-password"
                        fill="clear"
                        color="danger"
                        (click)="CancelPassword()">
                        <ion-icon slot="icon-only" name="close-circle-outline"></ion-icon>
                    </ion-button>
                </div>
            </upp-form-section>
        </div>

        <upp-form-buttons>
            <ion-button uppDataid="user-edit-submit-button" 
                size="large" 
                expand="block" 
                color="primary" 
                [disabled]="!CanAcceptChanges" 
                (click)="AcceptChanges()">
                {{tr('@user_modify_accept')}}
            </ion-button>
            <ion-button uppDataid="user-edit-cancel-button" 
                expand="block" 
                fill="clear" 
                color="primary" 
                (click)="CancelChanges()">
                {{tr('@user_modify_cancel')}}
            </ion-button>
        </upp-form-buttons>        
    </upp-form>
</ng-template>

<upp-visible-control mode="fill" [hidden]="!IsActive">
    <div uppDataid="user-hide-area" class="fixed" style="z-index: 1;" tabindex="0" (click)="OnClose()" (keydown.enter)="OnClose()" (keydown.space)="OnClose()"></div>
    <div class="right" [ngClass]="{ 'active': !IsHidden, 'mobile': view.Mobile }" style="z-index: 2;">
        <div class="form-box">
            <ng-container [ngTemplateOutlet]="userinfoform"></ng-container>
        </div>
    </div>
</upp-visible-control>
